import React from "react";
import ProductCard from "./ProductCard";

const ProductList = ({
  categories,
  menus,
  onAddToCart,
  handleFilterByCategory,
  filterOptions,
}) => {
  return (
    <div
      className="d-grid gap-2 p-2"
      style={{
        gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
        justifyContent: "center",
        maxHeight: "90vh", // Batasi tinggi agar bisa di-scroll
        overflowY: "auto", // Tambahkan scrollbar hanya di list produk
      }}
    >
      
      {menus.map((product) => (
        <ProductCard
          key={product.id}
          product={product}
          onAddToCart={onAddToCart}
          categories={categories}
        />
      ))}
    </div>
  );
};

export default ProductList;
